<template>
	<section>
        <div class="row">
            <div class="qualifier-tool-status-bar">
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">1</div>
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">2</div>
                <div class="qualifier-tool-status-number qualifier-tool-status-number-active">3</div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <h2>{{model.Step6Title}}</h2>
                <p class="qualifier-tool-subheader-alt">{{model.Step6SubTitle}}</p>
                <p class="qualifier-tool-subheader" v-html="(model.Step6DuplicateText)"></p>
            </div>
        </div>
        <div class="row d-flex justify-content-center qualifier-tool-footer" id="wtp-final-results">
            <a :href="model.Step6PaceOverviewUrl.replace('~', '..')" class="qualifier-tool-btn">{{model.Step6PaceOverviewTitle}}</a>
            <a :href="model.Step6InnovageOverviewUrl.replace('~', '..')" class="qualifier-tool-btn">{{model.Step6InnovageOverviewTitle}}</a>
        </div>
	</section>
</template>

<script>
	import SmoothScroll from 'smooth-scroll';
	import { mapState, mapActions, mapMutations } from 'vuex';

	export default {
		props: ['model'],
		data: function () {
			return {
			}
		},
		computed: mapState({
            qtResponse: state => state.WebQualifierTool.qtResponse
		}),
		components: {
		},
		mounted: function () {	
            let scroll = new SmoothScroll();
			let options = {
				header: '[data-scroll-header]',
                speed: 1000,
				offset: 250
			};
            let anchor = document.querySelector('#wtp-final-results');

            scroll.animateScroll(anchor, null, options);

            setTimeout(() => {
            	scroll.cancelScroll();
            }, 2000);
            if (window.dataLayer != null) {
                window.dataLayer.push({'event': 'Step6C'});    
            }
		},
		methods: {
        },
    }
</script>